import './styles.scss';

export default function initShardButtons() {}
